import { ApiBaseServiceProvider } from './ApiBaseServiceProvider';
import axios from 'axios';

export class ConnectorServiceProvider extends ApiBaseServiceProvider {
  scope = 'connector';

  validateAuth = (payload: { sourceType: string; credentials: Record<string, unknown>; workspaceId: string }) => {
    return axios.post(this.getBaseUrl() + 'validate-auth', payload, this.getRequestConfig());
  };

  register = (payload: Record<string, unknown>) => {
    return axios.post(this.getBaseUrl(), payload, this.getRequestConfig());
  };

  listByWorkspace = (workspaceId: string) => {
    return axios.get(this.getBaseUrl() + 'workspace/' + workspaceId, this.getRequestConfig());
  };

  browse = (connectorId: string, parentId?: string, pathPrefix?: string) => {
    const params: Record<string, string> = {};
    if (parentId) params.parentId = parentId;
    if (pathPrefix) params.pathPrefix = pathPrefix;
    return axios.get(this.getBaseUrl() + connectorId + '/browse', { ...this.getRequestConfig(), params });
  };

  triggerSync = (connectorId: string) => {
    return axios.post(this.getBaseUrl() + connectorId + '/sync', {}, this.getRequestConfig());
  };

  getSyncStatus = (connectorId: string, since?: number) => {
    const params = since !== undefined ? { since: String(since) } : {};
    return axios.get(this.getBaseUrl() + connectorId + '/sync-status', { ...this.getRequestConfig(), params });
  };

  getSyncStatuses = (connectorIds: string[]) => {
    const ids = connectorIds.join(',');
    return axios.get(this.getBaseUrl() + 'sync-statuses', {
      ...this.getRequestConfig(),
      params: { ids },
    });
  };

  update = (connectorId: string, payload: Record<string, unknown>) => {
    return axios.put(this.getBaseUrl() + connectorId, payload, this.getRequestConfig());
  };

  disconnect = (connectorId: string, keepArticles = false) => {
    return axios.delete(this.getBaseUrl() + connectorId, {
      ...this.getRequestConfig(),
      data: { keepArticles },
    });
  };

  reconnect = (payload: Record<string, unknown>) => {
    return axios.post(this.getBaseUrl() + 'reconnect', payload, this.getRequestConfig());
  };
}
